console.info("Actual environment: development");

export const environment = {
  production: false,
  serverAddress: "https://development.mrkresz.hu",
  classroomAddress: "https://development.server.classroom.mrkresz.hu"
};
